import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import Phaser from 'phaser';

export default class Cell extends AContainer {
  constructor(scene, key, showTitle = false, char = null, rows, colInd, rowInd) {
    super(scene);

    this.key = key;
    this.showTitle = showTitle;
    this.char = char;
    this.rows = rows;
    this.colInd = colInd;
    this.rowInd = rowInd;
    this.tile;
    this.isCorrect = false;
    this.dir;
  }

  // //////////////////////////
  // //// GRID FUNCTIONS //////
  // //////////////////////////

  initCell() {
    this.tile.enableTile();
  }

  getRandomNeighbor() {
    const arr = [this.aboveCell,this.belowCell,this.leftCell,this.rightCell];

    for (let a = arr.length - 1; a >= 0; a--) {
      if (arr[a] === undefined || arr[a] === null) {
        arr.splice(a, 1);
      }
    }

    for (let a = arr.length - 1; a >= 0; a--) {
      if (arr[a].tile.char === ' ' || arr[a].tile.char === '') {
        arr.splice(a, 1);
      }
    }

    if (gameData.swappedCells.length > 0) {
      for (let a = arr.length - 1; a >= 0; a--) {
        for (let s = 0; s < gameData.swappedCells.length; s++) {
          if (arr.length <= 0) {
            break;
          }
          else {
            if (arr[a] !== undefined && arr[a].tile.char === gameData.swappedCells[s].tile.char) {
              arr.splice(a, 1);
            }
          }
        }
      }
    }

    let randCell;
    if (arr.length > 0) {
      randCell = arr[Phaser.Math.Between(0, arr.length - 1)];
    }
    else {
      randCell = this;
    }

    gameData.swappedCells.push(randCell);

    return randCell;
  }

  swapRandomTile() {
    const swapCell = this.getRandomNeighbor();

    this.scene.addTween(swapCell.tile, 15, { x: this.x, y: this.y }, Phaser.Math.Easing.Linear);
    this.scene.addTween(
      this.tile,
      15,
      { x: swapCell.x, y: swapCell.y },
      Phaser.Math.Easing.Linear,
      () => {this.updateCell(swapCell);}
    );
  }

  swapTile(swapCell) {
    // console.log("swapping tiles", this.tile.char, swapCell.tile.char);
    this.scene.disableSwipe();

    if (gameData.gameStyle === 'Clsc') {
      this.scene.playSound('slide_classic');
    }
    else if (gameData.gameStyle === 'Camo') {
      this.scene.playSound('slide_camo');
    }
    else if (gameData.gameStyle === 'Wood') {
      this.scene.playSound('slide_wood');
    }
    else if (gameData.gameStyle === 'Sprng') {
      this.scene.playSound('slide_spring');
    }
    else if (gameData.gameStyle === 'Wntr') {
      this.tile.spin();
      this.scene.playSound('slide_winter');
    }
    else if (gameData.gameStyle === 'Atm') {
      this.scene.playSound('slide_autumn');
    }
    else if (gameData.gameStyle === 'Smr') {
      this.scene.playSound('slide_summer');
    }
    else if (gameData.gameStyle === 'Spc') {
      this.scene.playSound('slide_space');
    }
    else if (gameData.gameStyle === 'Uncrn') {
      this.scene.playSound('slide_unicorn');
    }
    else if (gameData.gameStyle === 'Neon') {
      this.scene.playSound('slide_tile ');
    }

    this.tile.setDir(this.getDir());
    swapCell.tile.setDir(swapCell.getDir());

    this.tile.setDepth(10);
    this.scene.addTween(swapCell.tile, 200, { x: this.x, y: this.y }, Phaser.Math.Easing.Linear);
    this.scene.addTween(
      this.tile,
      200,
      { x: swapCell.x, y: swapCell.y, scaleX: 1.25, scaleY: 1.25 },
      Phaser.Math.Easing.Linear,
      () => {
        this.scene.addTween(
          this.tile,
          200,
          { scaleX: 1, scaleY: 1 },
          Phaser.Math.Easing.Quadratic.In,
          () => {
            this.tile.doEffect();
            this.updateCell(swapCell, true);
          }
        );
      }
    );
  }

  updateCell(passedSwappedCell, nonRandom) {
    // console.log("OG ind", this.rows);
    const swappedCell = passedSwappedCell;
    const tempTile = this.tile;
    const swapTile = swappedCell.tile;

    this.tile = swapTile;
    swappedCell.tile = tempTile;

    this.tile.setDepth(2);

    if (!nonRandom) {
      gameData.updateCounter++;

      if (gameData.updateCounter === gameData.emptySpaces) {
        gameData.swappedCells = [];
        gameData.updateCounter = 0;
        this.scene.grid.updateGrid();
      }
    }
    else {
      this.scene.updateScore();
      this.scene.enableSwipe();
    }
  }

  calculateAdjacentCells(debugChar, returnDirCell) {
    // find adjacent cell references			
    const row = this.rows[this.rowInd];
    const totalCols = row.length;

    // above and below
    if (this.rowInd > 0) {
      this.aboveCell = this.rows[this.rowInd - 1][this.colInd]; // _orderIndex-cols;
    }
    if (this.rowInd < this.rows.length - 1) {
      this.belowCell = this.rows[this.rowInd + 1][this.colInd];
    }

    // left and right
    if (this.colInd > 0) {
      this.leftCell = row[this.colInd - 1];
    }
    if (this.colInd < totalCols - 1) {
      this.rightCell = row[this.colInd + 1];
    }

    if (debugChar) {
      if (this.tile.char === debugChar) {
        const arr = [this.aboveCell, this.belowCell, this.leftCell, this.rightCell];

        // console.log(this.tile.char);
        for (let a = 0; a < arr.length; a++) {
          const cell = arr[a];
          if (cell !== null) {
            // if(cell.char === " " || cell.char === "") console.log("found blank", a);
            console.log(cell.char, a);
          }
        }
      }
    }

    this.dir = returnDirCell;
    if (returnDirCell === 'left') return this.leftCell;
    if (returnDirCell === 'up') return this.aboveCell;
    if (returnDirCell === 'down') return this.belowCell;
    if (returnDirCell === 'right') return this.rightCell;
  }

  getCorrectChar() {
    return this.char;
  }

  getDir() {
    return this.dir;
  }

  getTile(char) {
    if (char) {
      return this.tile.char;
    }
    else {
      return this.tile;
    }
  }

  checkCorrect() {
    // console.log(this.char, this.getTile(true));
    if (String(this.char) === String(this.getTile(true))) {
      this.isCorrect = true;
    }
    else {
      this.isCorrect = false;
    }

    return this.isCorrect;
  }

  setTile(value) {
    this.tile = value;
  }
}